import React, { useState } from 'react';
import { Flame, TrendingUp, MessageSquare } from 'lucide-react';

const HotDiscussions = ({ discussions = [], onView }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (discussions.length === 0) return null;

  const icons = [
    <Flame size={14} className="text-orange-500" />,
    <Flame size={14} className="text-orange-400" />,
    <TrendingUp size={14} className="text-green-500" />,
  ];

  const displayedDiscussions = isExpanded ? discussions : discussions.slice(0, 4);
  const hasMore = discussions.length > 4;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-bold text-gray-900">Hot Discussions</h3>
        <Flame size={16} className="text-orange-500" />
      </div>
      <div className="space-y-4">
        {displayedDiscussions.map((d, i) => (
          <div 
            key={d.id} 
            className="flex items-start gap-2.5 cursor-pointer hover:bg-gray-50/50 p-1.5 -m-1.5 rounded-lg transition-colors"
            onClick={() => onView && onView(d)}
          >
            <div className="mt-0.5 flex-shrink-0">
              {icons[i] || <TrendingUp size={14} className="text-green-500" />}
            </div>
            <div className="min-w-0">
              <p className="text-sm font-medium text-gray-800 leading-snug line-clamp-2 break-words [overflow-wrap:anywhere]">
                {d.title}
              </p>
              <p className="text-xs text-gray-400 mt-0.5 flex items-center gap-1">
                <MessageSquare size={11} /> {d._count?.comments || 0} replies
              </p>
            </div>
          </div>
        ))}
      </div>
      
      {hasMore && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-4 w-full py-1.5 text-xs font-semibold text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors"
        >
          {isExpanded ? 'View Less' : `View More (${discussions.length - 4})`}
        </button>
      )}
    </div>
  );
};

export default HotDiscussions;
